export namespace Routes {
    export namespace Args {
        export const Id = 'id' as const;
        export const UserId = 'userId' as const;
        export const CampaignId = 'campaignId' as const;

        export function format(name: string) {
            return ':' + name;
        }

        export function combine(...parts: string[]) {
            return '/' + parts.filter(Boolean).join('/');
        }

        export function add(path: string, value: string | null) {
            return !value ? path : (path + '/' + value);
        }
    }

    // Dashboard
    export enum DashboardPages {
        Login = 'login',
        Signup = 'signup',
        ResetPassword = 'reset-password',
        Campaigns = 'campaigns',
        InnerCampaign = 'campaign',
        Users = 'users',
        UserInnerPage = 'user'
    }

    export function Dashboard(slug?: DashboardPages | string) { return `/dashboard${slug ? `/${slug}` : ''}`; }
    export namespace Dashboard {
        export const Home = Dashboard();
        export const Login = Dashboard(DashboardPages.Login);
        export const Signup = Dashboard(DashboardPages.Signup);
        export const ResetPassword = Dashboard(DashboardPages.ResetPassword);
        export const Campaigns = Dashboard(DashboardPages.Campaigns);
        export const CampaignInnerPage = (campaignId?: string) => (
            `${Dashboard(`${DashboardPages.Campaigns}/${DashboardPages.InnerCampaign}`)}${campaignId ? `?${Args.CampaignId}=${campaignId}` : ''}`
        );
        export const Users = Dashboard(DashboardPages.Users);
        export const UserInnerPage = (userId?: string) => (
            `${Dashboard(`${DashboardPages.Users}/${DashboardPages.UserInnerPage}`)}${userId ? `?${Args.UserId}=${userId}` : ''}`
        );
    }

    // Website
    export const Home = '/';
    export const page404 = '/404';
    export const Campaigns = '/spotify-campaigns';
    export const faq = '/faq';

    export function Checkout(slug?: string) { return `/checkout${slug ? `?slug=${slug}` : ''}`; }
}
